// These are constants that are only used on the `client`.
// TODO: Future file/folder location should probably change.

export const INDEX_NOT_FOUND = -1;
export const MAX_PAGE_OUTCOMES = 8;

// Engagement data time period keys
// The engagement data is keyed by number of days (e.g., 7, 30) or -1 for all-time data
export const ALL_TIME_DATA = -1;

export const WAITED_TOO_LONG_TIMEOUT_MS = 5000;

// Scrolling //

export const PAGE_SCROLL_CONTAINER_ID = "page-scroller";

// View state //
export const FOLLOWING_QUERY_PARAM = "following";
export const DEVTOOL_QUERY_PARAM = "devtools";
export const STUDENT_VIEW_QUERY_PARAM = "student";
export const TIMELINE_VIEW_QUERY_PARAM = "timeline";
export const ASSESSMENT_VIEW_QUERY_PARAM = "assessing";
export const TAB_QUERY_PARAM = "tab";

// Nav lists //
export const TOPIC_ID_QUERY_PARAM = "topic";
export const PAGE_ID_QUERY_PARAM = "page";
export const SIDEBAR_QUERY_PARAM = "sidebar";

export const COURSE_ID_QUERY_PARAM = "course-code";
export const COURSE_GROUPING_ID_QUERY_PARAM = "folder";
export const TERM_ID_QUERY_PARAM = "term";
// TODO: Revisit the query param for outcomes. We will likely want to query by outcome name instead of ID.
//       This will need to be changed for the section outcome page as well.
export const OUTCOME_ID_QUERY_PARAM = "outcome-id";

export const ACCESS_ID_QUERY_PARAM = "user";
export const SUBMISSION_ID_QUERY_PARAM = "submission";

// Content variants //

export const CATEGORY_QUERY_PARAM = "category";

// LOGO Sizes //
export const LOGO_DEFAULT_SIZE = 68;
export const LOGO_HEADER_SIZE = 88;
export const LOGO_FORM_SIZE = 124;

// Secondary overlays
// TODO: This is the same as the MOBILE_OVERLAY_QUERY_PARAM, should they be different?
export const SECONDARY_OVERLAY_QUERY_PARAM = "overlay";
export const SecondaryOverlay = {
  Outcomes: "outcomes",
  AssessmentSummary: "assessment_summary",
  AIAssistant: "ai",
  Users: "users",
  InstructorNotes: "instructor_notes",
  ClassChat: "chat",
  BreakoutSettings: "breakout_settings",
};
export const FOOTER_SECONDARY_OVERLAYS = [
  SecondaryOverlay.AIAssistant,
  SecondaryOverlay.Users,
  SecondaryOverlay.InstructorNotes,
  SecondaryOverlay.ClassChat,
  SecondaryOverlay.BreakoutSettings,
];

export type SecondaryOverlayType = (typeof SecondaryOverlay)[keyof typeof SecondaryOverlay];

// Mobile routing //
export const MOBILE_OVERLAY_ROUTE_QUERY_PARAM = "overlay";
export type MobileOverlayRouteType =
  | "menu"
  | "users"
  | "profile"
  | "instructor_notes"
  | "planner"
  | "ai"
  | "chat";
export const MOBILE_OVERLAY_ROUTES: MobileOverlayRouteType[] = [
  "menu",
  "users",
  "profile",
  "instructor_notes",
  "planner",
  "ai",
  "chat",
];
